import { FC, useContext, useEffect, useMemo } from "react"
import { EnterpriseComplianceDashboardContext } from "../contexts/EcdContext";
import { EnterpriseComplianceFiltersContext } from "../contexts/EcdFiltersContext";
import { EcdColorsContext } from "../contexts/EcdColorsContext";
import { EcdTilesEnum } from "../interfaces";
import EcdTopSpecialtiesFlyout from "../flyouts/EcdTopSpecialtiesFlyout";
import { tileFlyoutLink } from "../flyouts/EcdDrillInConfig";
import TopSpecialtiesTable from "../components/TopSpecialtiesTable";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import DashboardTile from "@app/shared/qes-standards/DashboardTile";

const TopSpecialtiesByGap: FC = () => {
    const filtersContext = useContext(EnterpriseComplianceFiltersContext);
    const dashboardContext = useContext(EnterpriseComplianceDashboardContext);
    const colorsContext = useContext(EcdColorsContext);
    const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;
    const title = `Top ${window.ecdTopSpecialtiesCount} Specialties by Gap Count`;

    useEffect(() => {
        dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.TopSpecialtiesByGap, true);
    }, []);

    useEffect(() => {
        if (dashboardContext.gapsBySpecialtyData?.length > 0) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.TopSpecialtiesByGap, false);
        }
    }, [dashboardContext.gapsBySpecialtyData]);

    useEffect(() => {
        if (!!filtersContext.apiReadyFilters) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.TopSpecialtiesByGap, true);
        }
    }, [filtersContext.apiReadyFilters]);

    const flyoutLinkTitle = useMemo(() => {
        if (!featureFlags.has(Features.ENABLE_ECD_DRILLINS) || dashboardContext.isDataEmptyMap.get(EcdTilesEnum.TopSpecialtiesByGap)) {
            return title;
        }
        const specialtiesProp = dashboardContext.gapsBySpecialtyData.map((sp) => ({
            groupCode: sp.specialtyGroupCode,
            id: sp.specialtyGroupId,
            name: sp.specialtyGroupDisplayName,
        }));

        return tileFlyoutLink(
            <EcdTopSpecialtiesFlyout specialties={specialtiesProp} />,
            "Top Specialties by Gap Count Details",
            filtersContext.isDashboardLoading || dashboardContext.isTileLoadingMap.get(EcdTilesEnum.TopSpecialtiesByGap),
            "top-specialties-by-gap__title-flyout",
            title,
        );
    }, [
        filtersContext.isDashboardLoading,
        dashboardContext.gapsBySpecialtyData,
        featureFlags.has(Features.ENABLE_ECD_DRILLINS),
        dashboardContext.isDataEmptyMap.get(EcdTilesEnum.TopSpecialtiesByGap),
        dashboardContext.isTileLoadingMap.get(EcdTilesEnum.TopSpecialtiesByGap)
    ]);

    return (
        <DashboardTile
            loading={filtersContext.isDashboardLoading || dashboardContext.isTileLoadingMap.get(EcdTilesEnum.TopSpecialtiesByGap)}
            title={flyoutLinkTitle}
            widthClass="col-md-12 col-xl-6"
        >
          <TopSpecialtiesTable
            tableData={dashboardContext.gapsBySpecialtyData}
            barHoverBackground={colorsContext.barHoverBackground }
            fillableGapsPrimary={colorsContext.fillableGapsPrimary}
            unfillableGaps={colorsContext.unfillableGaps}
            isExport={false}
          />
        </DashboardTile >
    )
};

export default TopSpecialtiesByGap;